module.exports = __webpack_public_path__ + "img/zdd_invite_tx_2.725e2bc6.png";